
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/subscription-invoices",
      function () {
        return require("private-next-pages/settings/subscription-invoices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/subscription-invoices"])
      });
    }
  